export enum RoleType {
    BOARDMEMBER = 'BOARDMEMBER',
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYER = 'EMPLOYER',
    PENSIONER = 'PENSIONER',
}
